import { LitState } from "@mds/core";

class MdsNavigationState extends LitState {

	static get stateVars() {
		return {
			breakpoint: '1024',
			break: false,
			isopen: false
		};
	}
}

export const navigationState = new MdsNavigationState();
